export const mconCheck = (cv_target) => {
  return !(G.mp.maker.mconManager?.isNonCommercial?.(cv_target) === true);
};
